<template>
  <div class="bg">
    <div class="wrapper">
      <!--第一步-->
      <div class="step-item">
        <div class="line">
          <span class="no">1</span>
        </div>
        <div class="content">
          <div class="title">
            <TaskStatus color="danger" status="已创建"/>
            <span class="grey">{{ assignedName }}</span>
          </div>
          <p class="name">{{ taskDetail?taskDetail.companyName:'' }}</p>
          <div class="desc">{{ taskDetail?taskDetail.description:'' }}</div>
          <div class="date">创建时间: {{ createDate }}</div>
        </div>
      </div>
      <!--第一步-->

      <!--第二步-->
      <div class="step-item">
        <div class="line" :class="isStep3?'':'secondary'">
          <span class="no" :class="isStep2?'':'secondary'">2</span>
        </div>
        <div class="content">
          <TaskStatus :color="isStep2?'info':'secondary'" status="处理中"/>
          <template v-if="taskDetail && taskDetail.progress!=='已创建'">
            <div class="desc">{{ taskDetail?taskDetail.createdNotes:'' }}</div>
            <template v-if="taskDetail.shippingProviderId">
              <div class="ship-info">快递公司: {{ taskDetail.shippingProviderName }}</div>
              <div class="ship-info">快递单号: {{ taskDetail.shippingNumber }}</div>
              <div class="ship-info mb-3">快递内容: {{ taskDetail.processingNotes }}</div>
            </template>
            <div class="date">处理时间: {{ lastUpdateDate }}</div>
          </template>
        </div>
      </div>
      <!--第二步-->

      <!--第三步-->
      <div class="step-item">
        <span class="no" :class="isStep3?'':'secondary'">3</span>
        <div class="content">
          <TaskStatus :color="isStep3?'success':'secondary'" status="已完成"/>
        </div>
      </div>
      <!--第三步-->

      <div class="spacer"></div>
      <div v-if="taskDetail" class="btn-group">
        <template v-if="taskDetail.shippingProviderId && (taskDetail.progress==='已完成' || taskDetail.progress==='正在处理')">
          <button class="info" @click="gotoDelivery">物流信息</button>
          <div class="gap"></div>
        </template>
        <button v-if="taskDetail.progress==='正在处理'" class="info" @click="done">完成</button>
      </div>
    </div>

    <DeliveryReminder
      v-if="showDeliveryReminder"
      :notes="taskDetail.processingNotes"
      @approve="approve"
      @deny="deny"/>
    <SubmitSuccessConfirm
      v-if="showSubmitSuccessConfirm"
      @finish="finish"/>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {dateFormat} from "vue-filter-date-format";
  import TaskStatus from '../../components/TaskStatus';
  import DeliveryReminder from '../../components/DeliveryReminder';
  import SubmitSuccessConfirm from '../../components/SubmitSuccessConfirm';

  export default {
    name: "TaskDetail",
    components: {
      TaskStatus,
      DeliveryReminder,
      SubmitSuccessConfirm
    },
    data() {
      return {
        showDeliveryReminder: false,
        showSubmitSuccessConfirm: false,
      }
    },
    computed: {
      ...mapGetters(['taskDetail']),
      id() {
        return this.$route.params.taskId;
      },
      assignedName() {
        if (this.taskDetail && this.taskDetail.assignedName) {
          return '受理人:' + this.taskDetail.assignedName;
        } else {
          return '未指派';
        }
      },
      createDate() {
        if (this.taskDetail && this.taskDetail.createDate) {
          return dateFormat(new Date(this.taskDetail.createDate + ''), "YYYY-MM-DD HH:mm:ss");
        } else {
          return '';
        }
      },
      lastUpdateDate() {
        if (this.taskDetail && this.taskDetail.lastUpdateDate) {
          return dateFormat(new Date(this.taskDetail.lastUpdateDate + ''), "YYYY-MM-DD HH:mm:ss");
        } else {
          return '';
        }
      },
      isStep2() {
        return this.taskDetail &&
          (this.taskDetail.progress === '正在处理' ||
            this.taskDetail.progress === '已完成');
      },
      isStep3() {
        return this.taskDetail && this.taskDetail.progress === '已完成';
      }
    },
    methods: {
      ...mapActions(['getTaskDetail', 'confirmDelivery', 'finishTask']),
      gotoDelivery() {
        this.$router.push({
          name: 'delivery',
          query: {
            id: this.id,
            shippingNumber: this.taskDetail.shippingNumber,
            shippingProviderName: encodeURI(this.taskDetail.shippingProviderName)
          }
        })
      },
      done() {
        if (this.taskDetail.shippingProviderId) {
          //需要确认物流物品
          this.showDeliveryReminder = true;
        } else {
          this.saveStep3();
        }
      },
      deny() {
        //否，关闭弹出框
        this.showDeliveryReminder = false;
      },
      approve() {
        //是,收到快递
        this.showDeliveryReminder = false;
        this.confirmDelivery({
          taskId: this.id, cb: () => {
            this.saveStep3();
          }
        });
      },
      finish() {
        //完成
        this.showSubmitSuccessConfirm = false;
      },
      saveStep3(){
        this.finishTask({
          item: this.taskDetail, cb: () => {
            //显示提交成功弹出框
            this.showSubmitSuccessConfirm = true;
          }
        });
      }
    },
    created() {
      window.document.title = '待办详情';
      this.getTaskDetail(this.id);
    }
  }
</script>

<style scoped>
  .wrapper {
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .title {
    display: flex;
    justify-content: space-between;
  }

  .grey {
    color: #999;
  }

  .step-item {
    display: flex;
    margin-bottom: 16px;
  }
  .name{
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
  }

  .step-item .no {
    width: 22px;
    height: 22px;
    display: block;
    background: #3579FF;
    color: #fff;
    text-align: center;
    line-height: 22px;
    border-radius: 50%;
    flex: 1 0 auto;
    margin-right: 20px;
    margin-top: 14px;
    position: relative;
  }

  .step-item .no::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-right: 8px solid #fff;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -20px;
    top: 6px;
  }

  .step-item .no.secondary {
    background: #ccc;
  }

  .step-item .line {
    position: relative;
  }

  .step-item .line::after {
    content: '';
    width: 1px;
    height: calc(100% - 13px);
    background: #3579FF;
    display: block;
    position: absolute;
    left: 10px;
    top: 40px;
  }

  .step-item .line.secondary::after {
    background: #ccc;
  }

  .step-item .content {
    width: 100%;
    /*height:197px;*/
    background: #fff;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    padding: 15px;
    flex: 1 1 auto;
  }

  .step-item .desc {
    margin: 8px 0 16px;
    line-height: 22px;
  }

  .step-item .date {
    color: #999;
  }

  .step-item .ship-info {
    color: #555;
    font-size: 13px;
    line-height: 20px;
  }

  .btn-group {
    width: 100%;
    display: flex;
  }

  .btn-group button {
    flex: 1;
  }

  .btn-group .gap {
    width: 10px;
  }

  .spacer {
    flex: 1 1 auto;
    height: 100%;
  }
</style>